// extracted by mini-css-extract-plugin
export default {"iframe":"index-module_iframe_eQo3l"};